module.exports = __webpack_public_path__ + "static/img/detail.8faa5bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail.png
// module id = zOyB
// module chunks = 3